import { InventoryCountCreatePage } from '@/features/inventory-count/pages/InventoryCountCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/inventory-count/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_count.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryCountCreatePage,
})